import { all, call } from 'redux-saga/effects';
import volume from './volume/volumeSagas';

export default function* blockSaga() {
	yield all(call(volume));
}
